export default __webpack_public_path__ + "static/media/PowellCatLocation-08.174ef2ca.jpg";